<template>
   
    <div> 
        <div class="crumbs" hidden="true"  style="margin-left:10px;">
            <el-breadcrumb separator="/">
                <el-breadcrumb-item>
                    <i class="el-icon-lx-calendar"></i> 产品管理
                </el-breadcrumb-item>
                <el-breadcrumb-item>渠道</el-breadcrumb-item>
            </el-breadcrumb>
        </div>
        
          <el-card shadow="hover"  class="searchChooseCard" >
                <span class="label-span">
                    <label class="label">导航名称</label> 
                    <el-input v-model.trim="query.name" placeholder="导航名称" class="handle-input mr15"></el-input> 
                </span>
                <span class="label-span">
                    <label class="label">导航分类</label>
                     <el-select v-model="form1.tid"  placeholder="导航分类" style="width:140px;margin-top:5px;" class="handle-input mr10" @change="getGoodsCode"  filterable  clearable  >
                         <el-option value="" label="全部"  />
                         <el-option v-for="item in select.option" :key="item.id" :label="item.optVal" :value="item.optKey" />
                     </el-select>
                </span>

                <span class="label-span">
                    <label class="label">导航状态</label> 
                    <el-select v-model="query.status"  placeholder="导航状态" clearable class="handle-select mr10">
                        <el-option value="" label="全部"  />  
                        <el-option value="1" label="启用"  /> 
                        <el-option value="0" label="停用"  /> 
                    </el-select>
                </span>   
                <el-button type="success" icon="el-icon-search"   @click="handleSearch">搜索</el-button>
                <el-button type="error" icon="el-icon-refresh"    @click="refreshSearch">重置</el-button>
                <el-button  type="primary"  icon="el-icon-lx-roundadd"   @click="addBind" >新增导航</el-button>
               
               
            </el-card>
            <el-card shadow="hover"  class="containCard" >
            <el-table :data="tableData" border class="table"  ref="multipleTable" header-cell-class-name="table-header"  @selection-change="handleSelectionChange"  >
                <!--<el-table-column type="selection" width="35" align="center"></el-table-column>--> 
                <el-table-column prop="name" min-width="160" align="left" label="导航名称"> </el-table-column>
                <el-table-column prop="tname" min-width="160" align="left" label="导航分类"> </el-table-column>
                <el-table-column prop="tname" min-width="160" align="left" label="导航图标">
                    <template slot-scope="scope" >
                        <img :src='scope.row.icon' style="height:50px;" />
                    </template>
                </el-table-column>
                <el-table-column prop="link" min-width="160" align="left" label="导航链接"> </el-table-column>
                <el-table-column prop="user" min-width="100" align="left" label="账号"> </el-table-column>
                <el-table-column prop="password" min-width="100" align="left" label="密码"> </el-table-column>
                <el-table-column prop="remarks" min-width="250" align="left" label="备注">
                    <template slot-scope="scope" >
                        <p style="font-size:12px;line-height:18px;">{{scope.row.descript}}</p>
                    </template>
                </el-table-column>
                <el-table-column prop="name" min-width="90" align="left" label="打开方式">
                    <template slot-scope="scope" >
                        <el-tag>{{scope.row.wtype==0?"当前窗口":"新窗口"}}</el-tag>
                    </template>
                </el-table-column>
                <el-table-column prop="status" min-width="90" align="center" label="导航状态">
                      <template slot-scope="scope" >   
                        <el-tooltip :content="scope.row.status=='1'?'导航已开启':'导航已关闭'" placement="top">
                            <el-switch @change="handleStatus(scope.$index, scope.row)"
                                v-model="scope.row.status"
                                active-color=""
                                inactive-color=""
                                active-value="1"
                                inactive-value="0">
                            </el-switch>
                        </el-tooltip>
                    </template> 
                </el-table-column>  
                <el-table-column prop="fb1" min-width="80" align="center"  label="排序"> </el-table-column>
                <el-table-column prop="createTime" min-width="160" align="center"  label="创建时间"> </el-table-column>
                <el-table-column label="操作" min-width="160" align="center"  fixed="right">
                    <template slot-scope="scope"> 
                        <span class='tableOperBtn' @click="handleEdit(scope.$index, scope.row)" ><i class='el-icon-edit'></i> 编辑</span>
                        <span class='tableOperBtn' @click="handDelete(scope.$index, scope.row)" ><i class='el-icon-delete'></i> 删除</span>
                    </template>
                </el-table-column>
                  
            </el-table>
            <div class="pagination">
                <el-pagination 
                   background
                    layout="total,  sizes,prev, pager, next,jumper"
                    :page-sizes="[10, 20, 50]"
                    :current-page="query.pageIndex"
                    :page-size="query.pageSize"
                    :total="pageTotal"
                    @size-change="handleSizeChange"
                    @current-change="handlePageChange" 
                ></el-pagination>
            </div>
        </el-card> 
        <!-- 新建自主渠道弹出框 --> 
        <el-dialog :close-on-click-modal="false" title="新增导航" :visible.sync="addVisible" :modal-append-to-body='false' top="80px" width="530px">
            <el-form ref="form1" :model="form1" label-width="120px"  @submit.native.prevent="saveForm">
                <el-form-item label="导航名称">
                    <el-input v-model.trim="form1.name"  placeholder="不超过10个字" style="width:360px;"></el-input>
                </el-form-item>
                <el-form-item label="导航图标">
                    <img :src="form1.icon" style="height:60px;margin-right:10px;vertical-align:middle">
                    <el-button @click="showIcon" style="margin-left:30px;">选择图标</el-button>
                </el-form-item>
                <el-form-item label="导航分类">
                    <el-select v-model="form1.tid"  placeholder="导航分类" style="width:140px;margin-top:5px;" class="handle-input mr10" @change="getGoodsCode"  filterable  clearable  >
                        <el-option v-for="item in select.option" :key="item.id" :label="item.optVal" :value="item.optKey" />
                    </el-select>
                </el-form-item>
                <el-form-item label="导航链接">
                    <el-input v-model.trim="form1.link"  placeholder="不超过10个字" style="width:360px;"></el-input>
                </el-form-item>
                <el-form-item label="账号">
                    <el-input v-model.trim="form1.user"  placeholder="不超过10个字" style="width:360px;"></el-input>
                </el-form-item>
                <el-form-item label="密码">
                    <el-input v-model.trim="form1.password"  placeholder="不超过10个字" style="width:360px;"></el-input>
                </el-form-item>
                <el-form-item label="备注">
                    <el-input v-model.trim="form1.remarks"  placeholder="不超过50个字" style="width:360px;"></el-input>
                </el-form-item>
                <el-form-item label="打开方式">
                    <el-radio-group v-model.trim="form1.wtype" >
                        <el-radio-button label="0">当前窗口</el-radio-button>
                        <el-radio-button label="1">新窗口</el-radio-button>
                    </el-radio-group>
                </el-form-item>

                <el-form-item label="导航排序" >
                    <el-input  v-model.trim="form1.fb1"  placeholder="数字越小，排序越靠前"></el-input>
                    <p>数字越小，排序越靠前</p>
                </el-form-item>
            </el-form>
            <span slot="footer" class="dialog-footer">
                <el-button @click="addVisible = false">取 消</el-button>
                <el-button type="primary" @click="saveForm">{{ isSubmitting ? '提交中...' : '提 交' }}</el-button>
            </span>
        </el-dialog>
         
  

        <!-- 编辑自主渠道弹出框 --> 
        <el-dialog :close-on-click-modal="false" title="编辑导航" :visible.sync="editVisible" :modal-append-to-body='false' top="50px" width="530px">
            <el-form ref="form3" :model="form3" label-width="120px">
                <el-form-item label="导航名称">
                    <el-input v-model.trim="form3.name"  placeholder="不超过10个字" style="width:360px;"></el-input>
                </el-form-item>
                <el-form-item label="导航图标">
                    <img :src="form3.icon" style="height:60px;vertical-align:middle">
                    <el-button @click="showIcon" style="margin-left:30px;">选择图标</el-button>
                </el-form-item>
                <el-form-item label="导航分类">
                    <el-select v-model="form3.tid"  placeholder="导航分类" style="width:140px;margin-top:5px;" class="handle-input mr10" @change="getGoodsCode"  filterable  clearable  >
                        <el-option v-for="item in select.option" :key="item.id" :label="item.optVal" :value="item.optKey" />
                    </el-select>
                </el-form-item>
                <el-form-item label="导航链接">
                    <el-input v-model.trim="form3.link"  placeholder="不超过10个字" style="width:360px;"></el-input>
                </el-form-item>
                <el-form-item label="账号">
                    <el-input v-model.trim="form3.user"  placeholder="不超过10个字" style="width:360px;"></el-input>
                </el-form-item>
                <el-form-item label="密码">
                    <el-input v-model.trim="form3.password"  placeholder="不超过10个字" style="width:360px;"></el-input>
                </el-form-item>
                <el-form-item label="备注">
                    <el-input v-model.trim="form3.remarks"  placeholder="不超过50个字" style="width:360px;"></el-input>
                </el-form-item>
                <el-form-item label="打开方式">
                    <el-radio-group v-model.trim="form3.wtype" >
                        <el-radio-button label="0">当前窗口</el-radio-button>
                        <el-radio-button label="1">新窗口</el-radio-button>
                    </el-radio-group>
                </el-form-item>

                <el-form-item label="导航排序" >
                    <el-input  v-model.trim="form3.fb1"  placeholder="数字越小，排序越靠前"></el-input>
                    <p>数字越小，排序越靠前</p>
                </el-form-item>
            </el-form>
            <span slot="footer" class="dialog-footer">
                <el-button @click="editVisible = false">取 消</el-button>
                <el-button type="primary" @click="saveEdit">确 定</el-button>
            </span>
        </el-dialog>

        <el-dialog :close-on-click-modal="false" title="查找图片" :modal-append-to-body='false' :visible.sync="showVisible" top="50px" width="1020px">
            <div style="width:100%;height:600px;overflow-y:scroll;margin-top:-30px;">
                <v-content2 ></v-content2>
            </div>
        </el-dialog>
          
    </div>
</template>

<script>
import bus from '../../../components/common/bus';
import vContent2 from '../sysConfig/ComImg.vue';
import {fetchData,saveForm,handDelete,changeForm,changeStatus,fetchDataDir} from '../../../api/nav';
import {fetchSelect} from '../../../api/navType';
export default {

    data() {
        return {  
            isSubmitting: false, // 是否正在提交
            Timeout:'', 
            activeNames:1,
            select:{ option:'',  },
            sendSms:{
                code:'', 
                content:'发送验证码',
                type:'danger',
                disabled:false,
                color:'color:#fff',
             },
            
            query: { 
                pageIndex: 1,
                pageSize: 10,  
            },
            tableData: [],
            tableData2: [],
            multipleSelection: [],
            delList: [],
            editVisible: false,
            editPlusVisible: false,
            addVisible: false,
            addPlusVisible:false,
            detailVisible:false, 
            dirVisible:false,
            showVisible:false,
            row:{},
            pageTotal: 0,
            form: {  
                ids:'',
                names:'',
            },
            form1: {
                wtype:'1',
                fb1:10,
            },
            form2: {   },
            form3: {   },
            form4: {   },
            idx: -1,
            id: -1
        };
    },
    created() {
        bus.$on('image-choose',  url  => {
            this.form1.icon = url;
            this.form3.icon = url;
            this.showVisible = false;
        });
    },
    components: {
        vContent2,
    },
    //页面加载方法
    mounted: function () { 
        //查询列表
        this.getData();
        this.getSelect();
    },

    methods: {  
        // 触发搜索按钮 
        handleSearch() {
            this.$set(this.query, 'pageIndex', 1);
            this.getData();
        },
        getSelect(){
            this.select.option = '';
            fetchSelect(this.select).then(res => {
                if(res.code=='200'){
                    this.select.option = res.data;
                }
            });
        },
        showIcon(){
            this.showVisible=true;
        },
        //重置按钮
        refreshSearch(){ 
            this.$set(this.query, 'name', '');  
            this.$set(this.query, 'status');    
            this.handleSearch();
        }, 
    

        //触发刷新按钮
        refresh(){
            history.go(0);
            
        }, 

        //查询
        getData(){
            fetchData(this.query).then(res => {  
                if(res.code=='200'){ 
                    this.tableData = res.data.list;
                    this.pageTotal = res.data.pageTotal ;  
                }else{
                    this.tableData = []; 
                    this.pageTotal = 0;
                } 
                
            });
        },
        //渠道字典表
        channelDir(){
            this.dirVisible=true;
            fetchDataDir(this.query).then(res => {  
                if(res.code=='200'){ 
                    this.tableData2 = res.data;   
                }else{
                    this.$message("暂无数据");
                } 
                
            });

        },
       

        // 新增渠道
        addBind() {
            this.addVisible = true; 
        },
        //保存新增
        saveForm() {   
            if (this.isSubmitting) return;
            this.isSubmitting = true; // 禁用按钮
            if( !this.form1.name ){
                this.isSubmitting = false;
                this.$message.error("请填写导航名称");
                return;
            }if( !this.form1.icon ){
                this.isSubmitting = false;
                this.$message.error("请选择导航图标");
                return;
            }if( !this.form1.tid ){
                this.isSubmitting = false;
                this.$message.error("请选择导航分类");
                return;
            }
            this.addVisible = false;  
            this.loading = true; 
            saveForm(this.form1).then(res => {
                this.loading = false; 
                this.isSubmitting = false;
                if(res.code=='200'){  
                    this.$message.success(res.message); 
                    this.refreshSearch(); 
                }else{
                    this.addVisible = true;  
                    this.$message.error(res.message); 
                } 
            });
        },

        

        // 编辑操作
        handleEdit(index, row) {      
            this.editVisible = true;
            this.form3 = row;
        },
 
        
        // 保存更改
        saveEdit() {   
            changeForm(this.form3).then(res => {
                if(res.code=='200'){
                    this.editVisible = false; 
                    this.$message.success(res.message); 
                    this.getData();
                }else{
                    this.$message.error(res.message); 
                }
            });
        },
        // q启用、禁用--改变状态
        handleStatus(index, row) {  
            var tips ;
            var content;
            if(row.status=='0'){ 
                row.status='1';
                tips = "禁用";
                content = "确定禁用吗？";
            }else{ 
                row.status = '0';
                tips = "启用";
                content = "确定启用吗？"; 
            }
            // 二次确认删除
            this.$confirm(content, '提示', {
                type: 'warning'
            }).then(() => { 
                if(row.status=='0'){ 
                    row.status='1' 
                }else{ 
                    row.status='0' 
                }
                changeStatus(row).then(res => {
                    if(res.code=='200'){ 
                        this.$message.success(tips+'成功'); 
                        this.getData();
                    }else{ 
                        if(row.status=='0'){ 
                            row.status='1' 
                        }else{ 
                            row.status='0' 
                        }
                        this.$message.error(tips+'失败');
                    } 
                });
            })
            .catch(() => {}); 
           
        },
 
        
        //详情
        handleDetail(index, row){
            this.form2 = row; 
            if(row.channelType=='1'){
                this.detailVisible = true; 
            }
            
        },
        // 删除
        handDelete(index, row) {
            this.$confirm('确定删除吗？', '提示', {
                type: 'warning'
            }).then(() => {
                handDelete(row).then(res => {
                    if(res.code=='200'){ 
                        this.$message.success('删除成功'); 
                        this.$set(this.query, 'pageIndex', 1); 
                        this.getData();
                    }else if(res.code=='201'){
                        //处理该等级绑定的成员
                        this.$message.error("该渠道商品仍有订单未结算，请手动结算订单！"); 
                    }else{
                        this.$message.error("删除失败"); 
                    } 
                });
            }) 
        },
        // 分页导航
        handlePageChange(val) { 
            this.$set(this.query, 'pageIndex', val);
            this.getData();
        },
        //分页数量更改导航
        handleSizeChange(val){
            this.$set(this.query, 'pageSize', val);
            this.getData();
        }
    }
};
</script>

<style scoped>
.label{
    background: #eee;
    font-size: 14px;
    height: 32px;
    display: inline-block;
    line-height: 33px;
    width:100px;
    text-align:center;
    color: #555;
  }
  .label-span{
      display: inline-block;
      height: 45px;
  }
.handle-box {
    width:100%;
    margin-bottom: 20px;
    overflow-x:auto;
}

.handle-select {
    width: 100px;
    display: inline-block;
}

.handle-input {
    width: 150px;
    display: inline-block;
}
.handle-del {
    float:right; 
}
.table {
    width: 100%;
    font-size: 14px;
}
.red {
    color: #ff0000;
}
.mr10 {
    margin-right: 10px;
    margin-left:0;
}
.mr15 {
    margin-right: 15px;
}
.table-td-thumb {
    display: block;
    margin: auto;
    width: 40px;
    height: 40px;
}
</style>
